import React, { createContext, useContext } from 'react';
import Icon from '@xo-union/tk-component-icons';
import { IconName as VendorIconName } from '@xo-union/dist-vendor-iconography';
import { IconName as StandardIconName } from '@xo-union/dist-iconography';
import styles from './iconToggle.scss';

const ToggleStateContext = createContext<{ size: string; toggleCallback: (id: string) => void } | undefined>(undefined);

interface Props {
  icon: VendorIconName | StandardIconName;
  id?: string;
  selected?: boolean;
  className?: string;
  iconLabel?: string;
}

export const IconToggle: React.FC<Props> = ({ icon, id = icon, selected = false, className, iconLabel }) => {
  const toggleContext = useContext(ToggleStateContext);

  const onClickHandler = () => {
    if (!selected && toggleContext) {
      toggleContext.toggleCallback(id);
    }
  };

  const iconToggleClassName = () => {
    return [className, selected ? styles.selected : ''].join(' ');
  };
  // mismatch of size type vs string
  const iconSize: any = toggleContext ? toggleContext.size : 'md';

  return (
    <div
      onClick={onClickHandler}
      className={iconToggleClassName()}
      data-testid={`toggle${selected ? '-selected' : ''}-${icon}`}
    >
      <Icon name={icon} size={iconSize} />
      {iconLabel && <span className={styles.iconLabel}> {iconLabel}</span>}
    </div>
  );
};

interface ContainerProps {
  label?: string;
  size?: string;
  className?: string;
  changeSelectedPreview: (selection: string) => void;
  updatedColors?: boolean;
}

export const IconToggleContainer: React.FC<ContainerProps> = ({
  label = '',
  size = 'md',
  changeSelectedPreview,
  children,
  className = '',
  updatedColors = false,
}) => {
  const toggleContext = { size: size, toggleCallback: changeSelectedPreview };
  const iconToggleClassName = updatedColors ? styles.iconToggleUpdated : styles.iconToggle;
  const classNameOverride = className ? `${iconToggleClassName} ${className}` : iconToggleClassName;

  return (
    <ToggleStateContext.Provider value={toggleContext}>
      {label ? <label className={styles.label}>{label}:</label> : ''}
      <div className={classNameOverride}>{children}</div>
    </ToggleStateContext.Provider>
  );
};
